/*
 *  Process Scripts
 *
 *  Created: 2021/05/13
 */

// Initialize Carousel Function
function initCarousel(container, options) {
  $(document).ready(function() {
    $(container).slick(options);
  })
}

// Accordion Scripts
var SLIDE_SELECTOR = '[data-accordion-slide]';
var TITLE_SELECTOR = 'data-accordion-title';
var NO_EXPAND_FIRST = 'data-no-expand';

var EXPANDED_CLASS = 'is-expanded';

function initAccordion(container) {
  if (container === null) {
    console.error('Accordion not found');
    return;
  }

  var slides = container.querySelectorAll(SLIDE_SELECTOR);

  function onSlideSelect(e) {
    e.preventDefault;
    var currentSlide = e.currentTarget;
    var target = e.target;

    // close active slide if unselected
    slides.forEach(function(slide) {
      if (slide !== currentSlide) {
        slide.classList.remove(EXPANDED_CLASS);
      }
    });

    // on active slide click, close active slide
    if (currentSlide.classList.contains(EXPANDED_CLASS)) {
      if (target.hasAttribute(TITLE_SELECTOR) || target.nodeName === "SPAN") {
        currentSlide.classList.remove(EXPANDED_CLASS);
      }
    } else {  // on inactive slide click, set as active slide
      currentSlide.classList.add(EXPANDED_CLASS);
    }
  }

  //expand first accordeon by default
  if (!container.hasAttribute(NO_EXPAND_FIRST)) {
    slides[0].classList.add(EXPANDED_CLASS);
  }

  slides.forEach(function(slide) {
    slide.addEventListener('click', onSlideSelect);
  })
}

// Login Register Page
var RESET_PASSWORD_TOGGLE = '[data-reset-password-toggle]';
var RESET_PASSWORD_FORM_SELECTOR = '[data-reset-password-form]';

function passwordToggle(e) {
  e.preventDefault
  var resetPasswordForm = document.querySelector(RESET_PASSWORD_FORM_SELECTOR);
  
  if (resetPasswordForm.classList.contains(EXPANDED_CLASS)) {
    resetPasswordForm.classList.remove(EXPANDED_CLASS);
    document.querySelectorAll(RESET_PASSWORD_TOGGLE).forEach(function(toggle) {
      toggle.classList.remove(EXPANDED_CLASS);
    });
  } else {
    resetPasswordForm.classList.add(EXPANDED_CLASS);
    document.querySelectorAll(RESET_PASSWORD_TOGGLE).forEach(function(toggle) {
      toggle.classList.add(EXPANDED_CLASS);
    });
  }
}

function initResetPasswordToggle() {
  document.querySelectorAll(RESET_PASSWORD_TOGGLE).forEach(function(toggle) {
    toggle.addEventListener('click', passwordToggle);
  });
}

initResetPasswordToggle();

// Loyalty Lion FAQs
var FAQS_CONTAINER = '[data-faq-container]';
var ACCORDION_BODY = '[data-accordion-container]';

function initTabAccordion() {
  document.querySelectorAll(FAQS_CONTAINER).forEach(function(faq) {
    faq.querySelectorAll(ACCORDION_BODY).forEach(function(accord) {
      initAccordion(accord);
    });
  });
}

initTabAccordion();

// Loyalty Lion Tabs Carousel
var REWARDS_TABS_CONTAINER = '[data-rewards-tabs]';
var REWARDS_TIER_CAROUSEL = '[data-loyalty-tiers]'
var rewardsTabsTiers = document.querySelector(REWARDS_TIER_CAROUSEL)
var rewardsTabsContainer = document.querySelector(REWARDS_TABS_CONTAINER);

function initTabCarousel () {
  initCarousel(rewardsTabsContainer, {
    mobileFirst: true,
    arrows: false,
    centerMode: true,
    infinite: false,
    slidesToShow: 1,
    draggable: true,
    variableWidth: true,

    swipe: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1099,
        settings: "unslick"
      }
    ]
  })

  // smooth scrolling on tab select
  var offsetHeight;

  if ($(window).width() >= 1100) {
    offsetHeight = 153;
  } else {
    offsetHeight = 122;
  }
  //console.log("hi top")
  // smooth scroll click event
  $('a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    //console.log("hi top2")
    $('html, body').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top - offsetHeight
      },
      500
    )
  })
}





// Loyalty Lion Tabs Functionality/Getting and setting active state
var REWARDS_SECTION = '[data-rewards-section]';
var REWARDS_TAB_SELECTOR = 'data-rewards-tabs-section';
var rewardsTabsSection = document.querySelector(REWARDS_TABS_CONTAINER);
var rewardsTabs = rewardsTabsSection ? rewardsTabsSection.querySelectorAll(`[${REWARDS_TAB_SELECTOR}]`) : '';

function setActiveTab(id, tabs, selector) {
  tabs.forEach(function(tab) {
    if (id === tab.getAttribute(selector)) {
      // if slider initialized, go to relevant heading
      if (rewardsTabsContainer.classList.contains('slick-initialized')) {
        var tabSlide = tab.closest('.slick-slide');
        $(REWARDS_TABS_CONTAINER).slick('slickGoTo', tabSlide.getAttribute('data-slick-index'));
      }
      tab.classList.add('current-section');
    } else {
      tab.classList.remove('current-section');
    }
  })
}

function setActiveSection(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      setActiveTab(entry.target.id, rewardsTabs, REWARDS_TAB_SELECTOR);
    }
  })
}

if (rewardsTabs) {
  var observerOptions = {
    rootMargin: '-30% 0px -70%'
  }
  
  var observer = new IntersectionObserver(setActiveSection, observerOptions);
  
  var rewardsSections = document.querySelectorAll(REWARDS_SECTION);
  
  rewardsSections.forEach(function(section) {
    observer.observe(section);
  });
}

// Back Button
var BACK_LINK = '[data-back-button]';

function backLinkInit() {
  var backLink = document.querySelector(BACK_LINK);

  if (!backLink) return;
  
  backLink.addEventListener("click", function(e) {
    e.preventDefault;
    history.back();
    return false;
  });
}

backLinkInit();

/*
 *  Loyalty Template Scripts
 *    Scripts that are only meant to run on the Loyalty Template.
 *
 *  Version:
 *    1.0.0 - 2022/05/26
 */

const SELECTOR_LOYALTY_TIERS_CAROUSEL = '[data-loyalty-tiers-carousel]';
const loyaltyTiersCarousel = document.querySelector(SELECTOR_LOYALTY_TIERS_CAROUSEL);

function initTierCarousel () {
  initCarousel(loyaltyTiersCarousel, {
    mobileFirst: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    draggable: true,
    swipe: true,
    adaptiveHeight: false,
    swipeToSlide: true,
    centerMode: true,
    infinite: true,
    responsive: [
      {
 
        breakpoint: 749,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          
        }
      },
      {
        breakpoint: 1099,
        settings: {
          centerMode: false,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1649,
        settings: "unslick"
      }
      
    ]
  })
}

$(window).on("load resize", function() {
  if (rewardsTabsTiers) {
    if (!rewardsTabsTiers.classList.contains('slick-initialized')) {
      initTierCarousel();
    }
  }
  if(rewardsTabsContainer){
    if (!rewardsTabsContainer.classList.contains('slick-initialized')) {
      initTabCarousel();
    }
  }
});


/*
 *  Loyalty Rules
 *    Scripts for adding additional loyalty rules.
 *
 *  Version:
 *    1.0.0 - 2020/03/20
 */

// const CONTAINER_SELECTOR = '[data-loyalty-rules]';
// const CUSTOM_RULES_SELECTOR = '[data-loyalty-rules-custom]';
// const LION_RULES_LIST = '.lion-rules-list';

// const container = $(CONTAINER_SELECTOR);
// const customRules = container.find(CUSTOM_RULES_SELECTOR);
// let lionRules;

// function addCustomRules() {
//   const rulesContent = customRules.html();

//   lionRules.append(rulesContent);
// };

// function checkLoyaltyLion(){
//   lionRules = container.find(LION_RULES_LIST);
 
//   if(!lionRules.length) return;

//   addCustomRules();
// }

// function loyaltyRules() {
//   setTimeout(() => checkLoyaltyLion(), 100);
// }


/**
 * Size guide scripts
 */

const SEL_SIZE_GUIDE_DRAWER = '[data-size-guide]';
const SEL_SIZE_GUIDE_TOGGLE = '[data-size-guide-toggle]';
const SEL_SIZE_GUIDE_ACCORDION = '[data-size-guide-accordion]';
const SEL_SIZE_GUIDE_TABLE = '[data-size-guide-table]';

const CLASS_DRAWER_OPEN = 'is-drawer-open';
const CLASS_SCROLL_DISABLED = 'is-scroll-disabled';

const sizeGuideToggle = document.querySelectorAll(SEL_SIZE_GUIDE_TOGGLE);
const sizeGuideDrawer = document.querySelector(SEL_SIZE_GUIDE_DRAWER);
const sizeGuideAccordion = document.querySelectorAll(SEL_SIZE_GUIDE_ACCORDION);
const sizeGuideTable = document.querySelectorAll(SEL_SIZE_GUIDE_TABLE);
const documentBody = document.querySelector('body');

const toggleDrawer = () => {
  sizeGuideDrawer.classList.toggle(CLASS_DRAWER_OPEN);
  documentBody.classList.toggle(CLASS_SCROLL_DISABLED);

  if(sizeGuideDrawer.classList.contains(CLASS_DRAWER_OPEN)) {
    // window.scrollTo({top: 0, behavior: 'smooth'});

    sizeGuideAccordion && sizeGuideAccordion[0].setAttribute('open', true);
  }
}

const updateActiveAccordion = (activeAccordion) => {
  const isOpen = activeAccordion.getAttribute('open') === 'true';
console.log(activeAccordion);
  sizeGuideAccordion.forEach((accordion) => {
      accordion.removeAttribute('open');
  });

  if(isOpen) {
    return;
  }

  activeAccordion.setAttribute('open', true);
}

sizeGuideToggle.forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
  
    toggleDrawer();
  })
})

sizeGuideAccordion.forEach((accordion) => {
  accordion.addEventListener('click', (e) => {
    updateActiveAccordion(e.target);
  })
})

sizeGuideTable.forEach((table) => {
  table.addEventListener('scroll', (e) => {
    const scrollLeft = e.target.scrollLeft;

    if(scrollLeft > 5) {
      table.classList.add('is-scrolled');
    } else {
      table.classList.remove('is-scrolled');
    }
  });
})